import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StarIcon from '@mulesoft/anypoint-icons/lib/svg/star.svg';
import * as refUtils from '~/utils/refs';
import styles from './RatingSelector.css';

export default class Star extends React.PureComponent {
  static propTypes = {
    value: PropTypes.number,
    selected: PropTypes.bool,
    highlighted: PropTypes.bool,
    isTabStop: PropTypes.bool,
    outOf: PropTypes.number,
    onClick: PropTypes.func,
    onHover: PropTypes.func,
    onLeave: PropTypes.func
  };

  static defaultProps = {
    selected: false,
    highlighted: false,
    isTabStop: false,
    outOf: -1,
    onHover: () => {},
    onLeave: () => {}
  };

  componentDidUpdate(prevProps) {
    if (this.props.selected && !prevProps.selected) {
      this.focus();
    }
  }

  starRef = React.createRef();

  focus = () => {
    refUtils.focus(this.starRef);
  };

  handleClick = () => {
    this.props.onClick(this.props.value);
  };

  handleMouseEnter = () => {
    this.props.onHover(this.props.value);
  };

  handleMouseLeave = () => {
    this.props.onLeave();
  };

  handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleClick();
    }
  };

  render() {
    const { value, outOf, selected, highlighted, isTabStop } = this.props;

    return (
      <span
        ref={this.starRef}
        role="radio"
        tabIndex={isTabStop ? 0 : -1}
        aria-checked={selected}
        aria-label={`${value} Star`}
        aria-posinset={value}
        aria-setsize={outOf}
        className={classNames(styles.star, {
          [styles.selected]: selected,
          [styles.highlighted]: highlighted
        })}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <StarIcon />
      </span>
    );
  }
}
